import styled from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

const ICON_CONTAINER_HEIGHT = 40;
const ICON_CONTAINER_WIDTH = 40;

export const B2CContainer = styled.div`
    padding: ${({ theme }) => theme.spacing.xxSmall};
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
`;

export const B2CWrapper = styled.div`
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Secondary_Alpha};
    border-radius: ${({ theme }) => theme.spacing.xSmall};
    padding: ${({ theme }) => `10px ${theme.spacing.small}`};
    color: ${({ theme }) => theme.colors[theme.colorMode].text_Med_Emphasis};
`;

export const IconContainer = styled.div(({ theme }) => ({
    display: "inline-flex",
    marginRight: `${theme.spacing.xSmall}`,
    alignItems: "center",
    height: `${ICON_CONTAINER_HEIGHT}px`,
    width: `${ICON_CONTAINER_WIDTH}px`,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    padding: theme.spacing.xxSmall,
    borderRadius: theme.spacing.xSmall,
    justifyContent: "center",
}));

export const Icon = styled(Image)(({ theme }) => ({
    height: `${theme.spacing.xxLarge}`,
    width: `${theme.spacing.xxLarge}`,
}));

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
